import { create } from "zustand";

type NucAppStore = {
  headerHeight: number;
  footerHeight: number;
  setHeaderHeight: (height: number) => void;
  setFooterHeight: (height: number) => void;

  getContentHeight: () => number;
};

export const useNucAppStore = create<NucAppStore>()((set, get) => ({
  headerHeight: 0,
  footerHeight: 0,

  setHeaderHeight: (height) => {
    set({ headerHeight: height });
  },
  setFooterHeight: (height) => {
    set({ footerHeight: height });
  },

  getContentHeight: () => {
    return window.innerHeight - get().headerHeight - get().footerHeight;
  },
}));
